import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=fd7e2556&"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn,QBreadcrumbs,QIcon,QBreadcrumbsEl,QChip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QForm,QSelect,QInput,QPopupProxy,QDate,QCheckbox,QTooltip,QSpace,QTable,QToggle,QTr,QTd,QField,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn,QBreadcrumbs,QIcon,QBreadcrumbsEl,QChip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QForm,QSelect,QInput,QPopupProxy,QDate,QCheckbox,QTooltip,QSpace,QTable,QToggle,QTr,QTd,QField})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
